import styled, { css } from "styled-components";

export const tabsStyles = css`
  div[id="tab-content"] {
    max-height: calc(80vh - 200px);
  }
`;

export const EditorUpdateActions = styled.div`
  font-family: "Rubik", sans-serif;
  display: flex;
  padding: 10px 16px;
  justify-content: flex-end;
  align-items: flex-start;
  gap: 10px;
  background: #1e1f43;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;

  [type="tertiary"] {
    color: white;
    border-radius: 4px;
    border: 1px solid #7a89f4;
    &:hover {
      background: transparent;
      color: white;
      border: 1px solid #7a89f4;
      border-radius: 4px;
    }
    line-height: 0px;
    padding: 14px 17px;
  }

  [type="primary"] {
    background-color: #36f99f;
    color: black;
    font-size: 14px;
    font-weight: 600;
    border: 1px solid transparent;
    transition: background-color 0.3s ease-in-out, color 0.3s ease-in-out;
    &:hover {
      background-color: #237f55;
      color: white;
    }
    line-height: 0px;
  }
`;

export const MainWrapper = styled.div`
  width: 90%;
  margin: 0 auto;
  border-radius: 6px;
  box-shadow: 0 0.625em 1.875em rgba(2, 2, 3, 0.28);
  position: sticky;
  top: calc(85px + 7.5vh);

  @media (width < 1500px) and (height < 860px) {
    top: calc(85px + 8vh);
  }

  @media (width < 1400px) and (height < 800px) {
    top: calc(85px + 10vh);
  }
`;
